module.exports = __webpack_public_path__ + "static/media/icon-drydoorlocked.679bf458.svg";